define('plugin/invoice/view/InvoiceRebillingFlagView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#invoice_payment_rebilling_flag_view',
        ui: {
            'rebillingFlag': ':input'
        },
        events: {
            'change @ui.rebillingFlag': 'onChangeFlag'
        },

        onChangeFlag: function () {
            this.triggerMethod('payment_processor:rebilling', this.ui.rebillingFlag.is(':checked'));
        }

    });

});
